import React from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface Props {
	message: string;
	imageAttachment: string | undefined;
}

const MessageContentPreview = ({ message, imageAttachment }: Props) => {
	return (
		<Paper sx={{ p: 2, mt: 2, width: "100%" }}>
			<Box sx={{ display: "flex", flexDirection: "column" }}>
				<Typography variant='body2' sx={{ textDecoration: "bold", mb: 2 }}>
					<b>Message</b>
				</Typography>

				<Typography variant='body1'>{message}</Typography>

				{Boolean(imageAttachment) && (
					<>
						<Typography variant='body2' sx={{ textDecoration: "bold", my: 2 }}>
							<b>Attached Image</b>
						</Typography>

						<img src={imageAttachment} alt='attachment' width='100%' />
					</>
				)}
			</Box>
		</Paper>
	);
};

export default MessageContentPreview;
